import { PutApiSpoUserSettingsBody, SpoUserSettingsResponse } from '@spo/types';
import { apiBff } from '.';

export const getConfiguration = async (): Promise<SpoUserSettingsResponse> => {
  return await apiBff.callBFF('GET', 'spo/user_settings');
};

export const setConfiguration = async (
  putApiSpoUserSettingsBody: PutApiSpoUserSettingsBody,
): Promise<SpoUserSettingsResponse> => {
  return await apiBff.callBFF(
    'PUT',
    'spo/user_settings',
    putApiSpoUserSettingsBody,
  );
};
